import * as React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useLocale } from "@/contexts/LocaleContext";
import type { RestorableItem } from "@/hooks/useAccountCartRestore";

interface Props {
  items: RestorableItem[] | null;
  isRestoring: boolean;
  onRestore: () => void;
  onKeepCurrent: () => void;
}

/**
 * حوار اختيار عند وجود سلّة محفوظة في الحساب وسلّة أخرى على الجهاز.
 * لا استعادة ولا مسح بلا إذن صريح من العميل.
 */
export function AccountCartRestoreDialog({
  items,
  isRestoring,
  onRestore,
  onKeepCurrent,
}: Props) {
  const { t } = useLocale();
  const open = !!items && items.length > 0;
  const count = items?.reduce((s, i) => s + i.quantity, 0) ?? 0;

  return (
    <AlertDialog open={open} onOpenChange={(o) => (!o ? onKeepCurrent() : undefined)}>
      <AlertDialogContent className="z-[70]">
        <AlertDialogHeader>
          <AlertDialogTitle>{t("cart.restore_title")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("cart.restore_body", { n: String(count) })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isRestoring} onClick={onKeepCurrent}>
            {t("cart.restore_keep_current")}
          </AlertDialogCancel>
          <AlertDialogAction
            disabled={isRestoring}
            onClick={(e) => {
              e.preventDefault();
              onRestore();
            }}
          >
            {isRestoring ? t("cart.restore_working") : t("cart.restore_confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
